<template>
  <div id='hj-container'>
    <header-layout activeIndex="aboutUs"></header-layout>
    <div class="aboutUs-bg1">
      <div class="aboutUs-carousel">
        <div class="carousel-word">
          <el-row>
            <el-col :span="4">
              <div><span class="text-bold">{{ year }}</span> <span class="font32"> 年</span></div>
            </el-col>
            <el-col :span="16">
              <div class="font32" style="line-height: 70px">{{ describe }}</div>
            </el-col>
            <el-col :span="4">
              <div>
                <el-button icon="el-icon-arrow-left" circle @click="prev"></el-button>
                <el-button icon="el-icon-arrow-right" circle @click="next"
                           style="background-color: #FE944C;color: #ffffff;border: 1px #FE944C solid"></el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-carousel :interval="8000" type="card" height="550px" indicator-position="none"
                     ref="carouse" @change="changeCarousel">
          <el-carousel-item v-for="(item,index) in list" :key="index">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.src "
              fit="fill"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="aboutUs-bg2">
      <img src="../../assets/img/aboutUs/1_02.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/aboutUs/1_04.jpg" class="bg2-rowImg" width="100%"/>
    </div>
    <div class="imgList">
      <div class="row-img img1">
        <div class="row-content">
          <div class="row-content-img1">
            <div class="icon1"></div>
          </div>
          <h3>保险全周期</h3>
          <p>保险产品设计,投保运营,营销全生命周期管理。</p>
        </div>
      </div>
      <div class="row-img img2">
        <div class="row-content">
          <div class="row-content-img2">
            <div class="icon2"></div>
          </div>
          <h3>系统智能化</h3>
          <p>高质量保险医疗语义理解能力的Ai保险大模型,日处理数据百万级,推动保险行业数字化转型。</p>
        </div>
      </div>
      <div class="row-img img3">
        <div class="row-content">
          <div class="row-content-img3">
            <div class="icon3"></div>
          </div>
          <h3>坚实数据基础</h3>
          <p>干万级别用户投保数据亿级用户诊疗数据,覆盖23省/241地市的业务范围。</p>
        </div>
      </div>
      <div class="row-img img4">
        <div class="row-content">
          <div class="row-content-img4">
            <div class="icon4"></div>
          </div>
          <h3>行业经验丰富</h3>
          <p>首批创新互联网门诊险产品实践者,累计保费超1亿;省级惠民保,百万级白领用户与新市民健康管理服务,累计用户超干万。
          </p>
        </div>
      </div>
    </div>
    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue';
import FooterLayout from '@/components/pc/FooterLayout.vue';

export default {
  name: "",
  components: {HeaderLayout, FooterLayout},
  data() {
    return {
      setActiveItem: 0,
      year: '2018',
      describe: '因朔桔(上海)智能科技有限公司在上海成立。',
      list: [
        {
          year: '2018',
          describe: '因朔桔(上海)智能科技有限公司在上海成立。',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20181727235257800.png'
        },
        {
          year: '2019',
          describe: '“药”+“医”+“险”+“服务”',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20191727235289851.png'
        },
        {
          year: '2020',
          describe: '完成由Pre-A轮融资,成立西安运营中心。',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20201727235304554.png'
        },
        {
          year: '2021',
          describe: '发布“惠安康”品牌,与头部三甲医院合作',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20211727235319136.png'
        },
        {
          year: '2022',
          describe: '发布“蓝云保”品牌,为医疗保障弱势群体提供保障。',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20221727235333521.png'
        },
        {
          year: '2023',
          describe: '平台积累用户超过5000万+人次',
          src: 'https://bucket-ysj-mall.oss-cn-shanghai.aliyuncs.com/20240925/prd20231727235359768.png'
        },
      ],
    }
  },
  mounted() {

  },
  methods: {
    changeCarousel(index) {
      this.setActiveItem = index
      let data = this.list[index]
      this.year = data.year
      this.describe = data.describe
    },
    prev() {
      this.setActiveItem == '0' ? this.$refs.carouse.setActiveItem(5) : this.$refs.carouse.setActiveItem(this.setActiveItem - 1);
    },
    next() {
      this.setActiveItem == '5' ? this.$refs.carouse.setActiveItem(0) : this.$refs.carouse.setActiveItem(this.setActiveItem + 1);
    },
  }
}
</script>

<style lang='scss' scoped>
#hj-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.aboutUs-bg1 {
  width: 100%;
  height: 900px;
  background-image: url("../../assets/img/aboutUs/12.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .aboutUs-carousel {
    width: 90%;
    padding: 80px 5%;
  }

  .carousel-word {
    width: 90%;
    padding: 0px 5% 80px;
    font-size: 60px;
    color: #FE944C;
  }
}

.carousel-list {
  height: 500px;
  width: 100%;
  background-size: 100% 100%;
}

.aboutUs-bg2 {
  padding-top: 40px;
}

.imgList {
  display: flex;
  align-items: center;
  justify-content: center;

  .row-img {
    margin: 100px 15px;
    width: 300px;
    height: 100%;
    height: 377px;
    background-repeat: no-repeat;

    &.img1 {
      background-image: url("../../assets/img/aboutUs/14.png");
    }

    &.img2 {
      background-image: url("../../assets/img/aboutUs/15.png");
    }

    &.img3 {
      background-image: url("../../assets/img/aboutUs/16.png");
    }

    &.img4 {
      background-image: url("../../assets/img/aboutUs/17.png");
    }

    .row-content {
      text-align: left;
      margin: 30px 35px 0;
      color: #ffffff;

      @mixin content-img {
        height: 90px;
        width: 90px;
        border-radius: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      @mixin iconStyle {
        margin: 20px;
        height: 45px;
        width: 45px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .row-content-img1 {
        @include content-img;
        background-color: #FF7278;

        .icon1 {
          @include iconStyle;
          background-image: url("../../assets/img/aboutUs/icon1-s.png");
        }
      }

      .row-content-img2 {
        @include content-img;
        background-color: #F7C42B;

        .icon2 {
          @include iconStyle;
          background-image: url("../../assets/img/aboutUs/icon2-s.png");
        }
      }

      .row-content-img3 {
        @include content-img;
        background-color: #FF8E3E;

        .icon3 {
          @include iconStyle;
          background-image: url("../../assets/img/aboutUs/icon3-s.png");
        }
      }

      .row-content-img4 {
        @include content-img;
        background-color: #FF7278;

        .icon4 {
          @include iconStyle;
          background-image: url("../../assets/img/aboutUs/icon4-s.png");
        }
      }
    }
  }

  h3 {
    margin-top: 20px;
    font-size: 26px;
    line-height: 60px;
    font-weight: bold;
  }

  p {
    font-size: 20px;
  }

  @mixin content-img-hover {
    color: #ffffff;
    background-image: none;
    border-radius: 10px;
    margin: -20px 15px 20px;
    transition: all 1000ms ease;
  }

  .img1 {
    &:hover {
      @include content-img-hover;
      background-color: #FF7278;


      .row-content-img1 {
        background-color: #FFFFFF;

        .icon1 {
          background-image: url("../../assets/img/aboutUs/icon1.png");
        }
      }

    }
  }

  .img2 {
    &:hover {
      @include content-img-hover;
      background-color: #F7C42B;

      .row-content-img2 {
        background-color: #FFFFFF;

        .icon2 {
          background-image: url("../../assets/img/aboutUs/icon2.png");
        }
      }

    }
  }

  .img3 {
    &:hover {
      @include content-img-hover;
      background-color: #F69734;

      .row-content-img3 {
        background-color: #FFFFFF;

        .icon3 {
          background-image: url("../../assets/img/aboutUs/icon3.png");
        }
      }

    }
  }

  .img4 {
    &:hover {

      @include content-img-hover;
      background-color: #FF7278;

      .row-content-img4 {
        background-color: #FFFFFF;

        .icon4 {
          background-image: url("../../assets/img/aboutUs/icon4.png");
        }
      }

    }
  }

}

::v-deep .el-carousel__mask {
  z-index: 200;
  background-color: #333333;
  opacity: .7;
}
</style>
